module.exports = __webpack_public_path__ + "static/submarine_cables-b3b682b0676af147ba5638eec276c536.png";